"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndustrialMicrobes = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Units_1 = require("../../Units");
class IndustrialMicrobes extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.INDUSTRIAL_MICROBES,
            tags: [Tags_1.Tags.MICROBE, Tags_1.Tags.BUILDING],
            cost: 12,
            productionBox: Units_1.Units.of({ energy: 1, steel: 1 }),
            metadata: {
                cardNumber: '158',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.energy(1).steel(1));
                }),
                description: 'Increase your Energy production and your steel production 1 step each.',
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.ENERGY, 1);
        player.addProduction(Resources_1.Resources.STEEL, 1);
        return undefined;
    }
}
exports.IndustrialMicrobes = IndustrialMicrobes;
//# sourceMappingURL=IndustrialMicrobes.js.map